import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Header } from 'components/app-header/styled';
import { Box, BoxProps } from 'components/ui';
import { getDesignToken } from 'styles/constants';

export const SignUpHeaderContainer = ({ style, ...props }: BoxProps & { reversed?: boolean }) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const SignUpHeader = ({ style, ...props }: BoxProps) =>
  React.createElement(Header, {
    ...props,
    style: [styles.header, style],
  });

export const BackArrowContainer = Pressable.withConfig({});

const styles = StyleSheet.create({
  container: {
    backgroundColor: getDesignToken('background-default'),
  },
  header: {
    backgroundColor: getDesignToken('background-default'),
  },
});
